// HU and IL legal are still in the process of approving the new buyer FX
// experience. These countries should be eligible in the near future.
export const BUYER_FX_INELIGIBLE_COUNTRIES: string[] = ['HU', 'IL'];

// See link below for information regarding Buyer FX eligibility

// https://engineering.paypalcorp.com/confluence/display/~jmurari/BuyerFX+eligibility

// The following card vendors do not support currency conversion so we have
// to use the 'PAYPAL' rate for any transaction that uses one of these cards
export const FORCED_PAYPAL_CONVERSION_CARD_BRANDS: string[] = [
  'CB_NATIONALE',
  'CBNATIONALE',
  'CETELEM',
  'COFIDIS',
  'COFINOGA',
  'DISCOVER',
  'JCB',
  'MAESTRO',
  'SOLO',
  'SWITCH',
];

// We have an agreement with AMEX to always allow them to perform conversion
export const FORCED_VENDOR_CONVERSION_CARD_BRANDS: string[] = ['AMEX'];
